const decorateEvent = (event) => {
  if (document.querySelector('meta[name="agent"]')) {
    return event + '.agent';
  }
  return event;
}

const dataLayerHandler = (event, value, formLocation) => {
  if (typeof window.dataLayer !== 'undefined') {
    const params = (typeof value !== 'object' && typeof value !== 'function')
      ? {
        event: decorateEvent(event),
        value: value ? value : '',
      }
      : {
        event: decorateEvent(event),
        ...value
      }
    if (formLocation) {
      params.formLocation = formLocation;
    }
    window.dataLayer.push(params);
  }
}

export default dataLayerHandler;

export const TRIP_SEARCH = 'trip.search';
export const TRIP_SUBMIT = 'trip.submit';
export const TRIP_SAVE_DRAFT = 'trip.save.draft';
export const TRIP_PAYMENT = 'trip.payment';
export const TRIP_CONFIRMED = 'trip.confirmed';
export const CHARTER_SEARCH = 'charter.search';


export const TRIP_PICKUP = 'trip.pickup';
export const TRIP_DROPOFF = 'trip.dropoff';
export const TRIP_PAX = 'trip.pax';
export const TRIP_DATE = 'trip.date';
export const TRIP_TIME = 'trip.time';
export const TRIP_TERMINAL = 'trip.terminal';
export const TRIP_SELECT = 'trip.select';
export const TRIP_EXTRA = 'trip.extra';
export const TRIP_TOTAL = 'trip.total';

export const TRIP_RETURN_PICKUP = 'trip.return.pickup';
export const TRIP_RETURN_DROPOFF = 'trip.return.dropoff';
export const TRIP_RETURN_PAX = 'trip.return.pax';
export const TRIP_RETURN_DATE = 'trip.return.date';
export const TRIP_RETURN_TIME = 'trip.return.time';
export const TRIP_RETURN_TERMINAL = 'trip.return.terminal';
export const TRIP_RETURN_SELECT = 'trip.return.select';
export const TRIP_RETURN_EXTRA = 'trip.return.extra';

export const PAX_NAME = 'pax.name';
export const PAX_EMAIL = 'pax.email';
export const PAX_PHONE = 'pax.phone';

export const CARD_DETAILS_COMPLETE = 'card.complete';
export const CARD_DETAILS_ERROR = 'card.error';
export const CARD_DETAILS_INCOMPLETE = 'card.incomplete';



